"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./baseLink.scss");
const react_1 = __importDefault(require("react"));
function Link(props) {
    const triggerOnCLick = () => {
        if (props.onClickAction) {
            props.onClickAction();
        }
    };
    return (react_1.default.createElement("a", { className: `base-link ${props.className ? props.className : ""}`, href: props.type === "mail" ? `mailto:${props.href}` : props.href, title: props.title, onClick: triggerOnCLick, target: props.openInNewTab ? "_blank" : undefined, rel: props.rel != undefined
            ? props.rel
            : props.openInNewTab
                ? "noreferrer"
                : undefined, style: Object.assign({}, props.styles) },
        react_1.default.createElement("span", { className: "text" }, props.text)));
}
exports.default = Link;
